import React from "react";
import DataService from "../helpers/DataService";
import Lang from "../helpers/Lang";
import Consts from "../helpers/Consts";
import Utils from "../helpers/Utils";
import Carousel from "./Carousel/Carousel";
import ImageMeasurer from "./ImageMeasurer/ImageMeasurer";
import Explorer from "./Explorer/Explorer";
import CategoryInfo from "./CategoryInfo/CategoryInfo";
import sortBy from "sort-by";
import _ from "lodash";
import scrollToElement from "scroll-to-element";

class Nettgalleri extends React.Component {
  constructor(props) {
    super(props);

    this.tempList = [];
    Lang.lang = window.cmsData.configs.lang;
    Consts.list.numberOfElements = window.cmsData.configs.listNumberOfElements;
    Consts.categories.numberOfElements =
      window.cmsData.configs.categoriesNumberOfElements;

    Utils.dom.breadcrumb.addLinkToSelf();

    this.state = {
      sourceItems: [],
      viewItems: [],
      slide: 0,
      cmsData: window.cmsData,
      itemsPerRow: 4,
      numberOfShowing: Consts.list.numberOfElements,
      gridItems: [],
      sortedBy: "relevance",
      apiSearchError: false,
      apiAllError: false,
      apiCategoryContentError: false,
      searchHasNoHits: false,
      title: window.cmsData.title,
      gridTitle: window.cmsData.showsHitsText,
      minAndMaxYear: { min: 0, max: parseInt(new Date().getFullYear()) },
      currentCategory: null,
      activeTab: 0,
      oldViewItems: [],
      oldSlide: 0,
      oldGridItems: [],
      isSeries: false,
      multipleActive: false,
    };
  }

  _changeActiveItem = (slide) => {
    Utils.url.setParameterId(this.state.viewItems[slide]);
    this.setState({ slide });
  };

  _setVersions = (newArr, historyNavigation = false) => {
    // Series
    if (newArr[0].isSeries) {
      let activeIndex = _.findIndex(newArr, (item) => {
        return (
          item["identifier.id"] ===
          this.state.viewItems[this.state.slide]["identifier.id"]
        );
      });
      this.setState({
        oldViewItems: this.state.viewItems,
        oldSlide: this.state.slide,
        viewItems: newArr,
        isSeries: true,
        slide: activeIndex,
        multipleActive: true,
        oldGridItems: this.state.gridItems,
        gridItems: newArr,
        oldGridTitle: this.state.cmsData.showsHitsText,
        gridTitle: this.state.cmsData.seriesHitsText,
      });
    }
    // Versions
    else {
      this.setState({
        oldViewItems: this.state.viewItems,
        oldSlide: this.state.slide,
        viewItems: newArr,
        isSeries: false,
        slide: 0,
        multipleActive: true,
        oldGridItems: this.state.gridItems,
        gridItems: newArr,
        oldGridTitle: this.state.cmsData.showsHitsText,
        gridTitle: this.state.cmsData.versionsHitsText,
      });
    }
    scrollToElement("#gallery-grid", {
      offset: -190,
      ease: "in-sine",
      duration: 300,
    });
  };

  _endVersions = () => {
    this.setState({
      viewItems: this.state.oldViewItems,
      slide: this.state.oldSlide,
      multipleActive: false,
      isSeries: false,
      gridItems: this.state.oldGridItems,
      gridTitle: this.state.cmsData.showsHitsText,
    });
  };

  _clickThumb = (slide) => {
    this._changeActiveItem(slide);
    history.pushState(
      { activeSlide: slide, type: "clickThumb" },
      null,
      document.location.href
    );
  };

  _clickCategory = (category, rows, start, historyNavigation = false) => {
    this._resetList();
    this.setState({ activeCategory: category });
    if (!category) {
      if (!historyNavigation) {
        history.pushState(
          { cat: "", type: "resetCategory" },
          null,
          document.location.href
        );
      }
    } else {
      this._getCategoryContentData(category, rows, start);
      if (!historyNavigation) {
        history.pushState(
          { cat: category, type: "clickCategory" },
          null,
          document.location.href
        );
      }
    }
  };

  _toggleTab = (tab) => {
    this.setState({ activeTab: tab });
  };

  _getCategoryContentData = (category, rows, start) => {
    DataService.getCategoryContent(
      (jsonData) => {
        this.tempList = this.tempList.concat(jsonData.docs);

        if ((Number(jsonData.numFoundOnServer) > 0 &&
              this.tempList.length < jsonData.numFoundOnServer) ||
              this.tempList.length < jsonData.numFound) {
          this._getCategoryContentData(category, rows, this.tempList.length);
        } else {
          this.tempList = this._mappedArrayForSorting(this.tempList).sort(
            sortBy("title")
          );
          Utils.url.setParameterId(this.tempList[0]);
          this.setState({
            viewItems: this.tempList,
            gridItems: this.tempList.slice(0, this.state.numberOfShowing),
            slide: 0,
            sortedBy: "title-asc",
            title: `${this.state.cmsData.title} – ${category.category}`,
            gridTitle: this.state.cmsData.categoriesHitsText.replace(
              Consts.selectors.category,
              category.category
            ),
            currentCategory: category,
          });
          Utils.dom.breadcrumb.addCategory(category);
          this.tempList = [];
          setTimeout(() => {
            scrollToElement("#gallery-category-info", {
              offset: -80,
              ease: "in-sine",
              duration: 300,
            });
          }, 200);
        }
      },
      (error) => {
        this.setState({
          apiCategoryContentError: true,
        });
      },
      category.id,
      rows,
      start
    );
  };

  _resetList = () => {
    this.setState({
      viewItems: this.state.sourceItems,
      gridItems: this.state.sourceItems.slice(0, this.state.numberOfShowing),
      slide: 0,
      sortedBy: "relevance",
      title: this.state.cmsData.title,
      searchHasNoHits: false,
      gridTitle: this.state.cmsData.showsHitsText,
      currentCategory: null,
      multipleActive: false,
      isSeries: false,
    });
    Utils.url.setParameterId(this.state.sourceItems[0]);
    Utils.dom.breadcrumb.removeCurrentCategory();
  };

  _showMore = () => {
    const incrementBy = Consts.list.numberOfElements;
    const newCount = this.state.numberOfShowing + incrementBy;
    const listLength = this.state.viewItems.length;

    if (newCount <= listLength) this.setState({ numberOfShowing: newCount });
    else this.setState({ numberOfShowing: this.state.gridItems.length });

    this.setState({
      gridItems: this.state.viewItems.slice(0, newCount),
    });
  };

  _mappedArrayForSorting = (array) => {
    return array.map(function (item) {
      if (!!item["artifact.ingress.title"] && !item.title) {
        item.title = item["artifact.ingress.title"];
      }
      item.year = item["artifact.ingress.production.toYear"];
      item.artistLastName = item["artifact.ingress.producer"];
      return item;
    });
  };

  _translateSortedBy = (key) => {
    const data = this.state.cmsData;
    switch (key) {
      case Consts.sort.relevance:
        return data.sortRelevanceText;
      case Consts.sort.titleAsc:
        return data.sortTitleAscText;
      case Consts.sort.timeAsc:
        return data.sortTimeAscText;
      case Consts.sort.timeDesc:
        return data.sortTimeDescText;
      case Consts.sort.artistLastnameAsc:
        return data.sortArtistLastnameText;
      default:
        return data.sortRelevanceText;
    }
  };

  _sortBy = (by) => {
    let sortedArr = [];
    sortedArr = this._mappedArrayForSorting(this.state.viewItems);
    if (by == "relevance") {
      Utils.lists.shuffleArray(sortedArr);
    }
    if (by == "title-asc") {
      sortedArr.sort(sortBy("title"));
    }
    if (by == "title-desc") {
      sortedArr.sort(sortBy("-title"));
    }
    if (by == "time-desc") {
      sortedArr = _.orderBy(
        sortedArr,
        [
          (data) => {
            if (data["year"] === null) {
              data["year"] = "";
            }
            return data["year"] || "";
          },
        ],
        ["desc"]
      );
    }
    if (by == "time-asc") {
      sortedArr = _.orderBy(
        sortedArr,
        [
          (data) => {
            if (data["year"] === null) {
              data["year"] = "";
            }
            return data["year"];
          },
        ],
        ["asc"]
      );
    }
    if (by == "artist-lastname-asc") {
      sortedArr.sort(sortBy("artistLastName"));
    }

    this.setState({
      viewItems: sortedArr,
      gridItems: sortedArr.slice(0, this.state.numberOfShowing),
      sortedBy: by,
      slide: 0,
    });
  };

  _search = (
    query,
    yearFrom,
    yearTo,
    rows,
    start,
    historyNavigation = false
  ) => {
    this._resetList();
    DataService.getSearch(
      (jsonData) => {
        this.tempList = this.tempList.concat(jsonData.docs);
        if (this.tempList.length < jsonData.numFound) {
          this._search(
            query,
            yearFrom,
            yearTo,
            rows,
            this.tempList.length,
            true
          );
        } else {
          if (this.tempList.length > 0) {
            Utils.url.setParameterId(this.tempList[0]);
          }
          const hasNoHits = this.tempList.length === 0;
          this.setState({
            viewItems: this.tempList,
            gridItems: this.tempList,
            slide: 0,
            sortedBy: "relevance",
            searchHasNoHits: hasNoHits,
            gridTitle: hasNoHits
              ? this.state.cmsData.searchNoHitsText.replace(
                  Consts.selectors.search,
                  query
                )
              : this.state.cmsData.searchHitsText.replace(
                  Consts.selectors.search,
                  query
                ),
          });
          this.tempList = [];
          setTimeout(() => {
            scrollToElement("#gallery-grid", {
              offset: -90,
              ease: "in-sine",
              duration: 300,
            });
          }, 200);
        }
      },
      (error) => {
        this.setState({
          apiSearchError: true,
          searchHasNoHits: false,
        });
      },
      query,
      yearFrom,
      yearTo,
      rows,
      start
    );
    this.setState({ activeTab: 1 });
    if (!historyNavigation) {
      history.pushState(
        {
          search: { query: query, sliderMin: yearFrom, sliderMax: yearTo },
          type: "search",
        },
        null,
        document.location.href
      );
    }
  };

  _getAllData = (rows, start) => {
    DataService.getAll(
      (jsonData) => {
        this.tempList = this.tempList.concat(jsonData.docs);

        if (this.tempList.length < jsonData.numFound) {
          this._getAllData(rows, this.tempList.length);
        } else {
          Utils.lists.shuffleArray(this.tempList);
          const minMaxYear = Utils.lists.minAndMaxYearFromList(this.tempList);
          var parameterSlide = Utils.url.getParameterIndex(
            this.tempList,
            this.state.slide,
            this.state.cmsData.prioritizedImage
          );

          this.setState({
            sourceItems: this.tempList,
            viewItems: this.tempList,
            gridItems: this.tempList.slice(0, this.state.numberOfShowing),
            slide: parameterSlide,
            gridTitle: this.state.cmsData.showsHitsText,
            minAndMaxYear: minMaxYear,
          });
          this.tempList = [];
        }
      },
      (error) => {
        console.error(error);
        this.setState({
          apiAllError: true,
        });
      },
      rows,
      start
    );
  };

  UNSAFE_componentWillMount() {
    this._getAllData(Consts.api.numberOfElements, 0);
  }

  componentDidMount() {
    const self = this;

    window.onpopstate = function (event) {
      // back to initial load
      if (!history.state) {
        self._clickCategory(null, Consts.api.numberOfElements, 0, true);
        self.setState({
          activeTab: 0,
        });
      } else {
        if (history.state.type == "clickCategory") {
          const category = history.state.cat;
          self.setState({
            activeTab: 0,
          });
          self._clickCategory(category, Consts.api.numberOfElements, 0, true);
        }
        if (history.state.type == "resetCategory") {
          self._clickCategory(null, Consts.api.numberOfElements, 0, true);
          self.setState({
            activeTab: 0,
          });
        }

        if (history.state.type == "search") {
          const query = history.state.search.query;
          const sliderMin = history.state.search.sliderMin;
          const sliderMax = history.state.search.sliderMax;
          self._search(
            query,
            sliderMin,
            sliderMax,
            Consts.api.numberOfElements,
            0,
            true
          );
          self.setState({
            activeTab: 1,
          });
          document.getElementById(
            "gallery-explorer-input-search"
          ).value = query;
        }
        if (history.state.type == "clickThumb") {
          history.back();
        } else {
          self._clickCategory(null, Consts.api.numberOfElements, 0, true);
        }
      }
    };
  }

  render() {
    const { slide } = this.state;
    const goPrevSlide = this._changeActiveItem.bind(this, slide - 1);
    const goNextSlide = this._changeActiveItem.bind(this, slide + 1);
    let versionsActive = this.state.multipleActive && !this.state.isSeries;
    return (
      <div>
        <div className="row">
          <div className="large-8 columns">
            <div className="page-title">
              <h1>{this.state.title}</h1>
            </div>
            {this.state.cmsData.ingress && (
              <div
                className="article-excerpt"
                dangerouslySetInnerHTML={{
                  __html: this.state.cmsData.ingress,
                }}
              />
            )}
          </div>
        </div>
        <div className="row page-section section-gallery-carousel">
          <div className="large-12 columns">
            <Carousel
              item={this.state.viewItems[slide] || {}}
              viewItems={this.state.viewItems}
              sourceItems={this.state.sourceItems}
              slide={slide}
              prevSlide={[slide > 0, goPrevSlide]}
              nextSlide={[slide < this.state.viewItems.length - 1, goNextSlide]}
              changeSlide={this._changeActiveItem}
              cmsData={this.state.cmsData}
              searchHasNoHits={this.state.searchHasNoHits}
              multipleActive={this.state.multipleActive}
              setVersions={this._setVersions}
              endVersions={this._endVersions}
            />
          </div>
        </div>
        <div
          className="row page-section section-gallery-explorer"
          id="gallery-explorer"
        >
          <div className="large-12 columns">
            <Explorer
              items={this.state.sourceItems}
              search={this._search}
              clickCategory={this._clickCategory}
              resetList={this._resetList}
              cmsData={this.state.cmsData}
              activeCategory={this.state.currentCategory}
              activeTab={this.state.activeTab}
              toggleTab={this._toggleTab}
              apiCategoryContentError={this.state.apiCategoryContentError}
              minMax={this.state.minAndMaxYear}
            />
          </div>
        </div>
        {this.state.currentCategory && (
          <CategoryInfo
            category={this.state.currentCategory}
            cmsData={this.state.cmsData}
          />
        )}
        <div
          className="row page-section section-gallery-grid"
          id="gallery-grid"
        >
          <div className="large-12 columns">
            {this.state.apiSearchError ||
            this.state.apiAllError ||
            this.state.apiCategoryContentError ? (
              <h3>{this.state.cmsData.noContactText}</h3>
            ) : (
              <div>
                {!!this.state.viewItems.length && (
                  <ImageMeasurer
                    items={this.state.viewItems}
                    gridItems={this.state.gridItems}
                    updateSlider={this._setActive}
                    clickThumb={this._clickThumb}
                    sortBy={this._sortBy}
                    showMore={this._showMore}
                    sortedBy={this._translateSortedBy(this.state.sortedBy)}
                    cmsData={this.state.cmsData}
                    gridTitle={this.state.gridTitle}
                    noDateText={this.state.cmsData.noDateText}
                  />
                )}
                {!this.state.viewItems.length && (
                  <div className="gallery-list-info">
                    <h3>
                      {this.state.searchHasNoHits
                        ? this.state.gridTitle
                        : this.state.cmsData.noHitsText}
                    </h3>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="row page-section">
          <div className="large-8 columns">
            <div
              dangerouslySetInnerHTML={{
                __html: this.state.cmsData.bottomText,
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Nettgalleri;
